import { Button, Divider, Dropdown } from 'antd';
import React, { useMemo, useRef, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Code, Columns, Product, Text, Type } from 'app/shared/assets';
import s from './index.module.scss';
import { useClickOutside } from 'app/hooks/useClickOutside';
export const LendingDivider = ({
    onHeader,
    onTypes,
    onProducts,
    onMarkdown,
    onColumns,
}) => {
    const [isMenu, setIsMenu] = useState(false);
    const clickRef = useRef();
    const menu = useMemo(() => {
        return [
            {
                key: '1',
                label: 'Заголовок',
                icon: <Text />,
                onClick: onHeader,
            },
            {
                key: '2',
                label: 'Категории',
                icon: <Type />,
                onClick: onTypes,
            },
            {
                key: '3',
                label: 'Колонки',
                icon: <Columns />,
                onClick: onColumns,
            },
            {
                key: '4',
                label: 'Товары',
                icon: <Product />,
                onClick: onProducts,
            },
            {
                key: '5',
                label: 'HTML-код',
                icon: <Code />,
                onClick: onMarkdown,
            },
        ];
    }, [onHeader, onTypes, onProducts, onMarkdown, onColumns]);
    const onClickOutside = () => setIsMenu(false);
    useClickOutside(clickRef, onClickOutside);
    return (
        <Divider>
            <div className={s.dropdown_wrap} ref={clickRef}>
                <Button
                    shape={'circle'}
                    icon={<PlusOutlined />}
                    onClick={() => setIsMenu((prev) => !prev)}
                />
                {isMenu && (
                    <div className={s.dropdown}>
                        {menu.map((el) => (
                            <div
                                key={el.key}
                                onClick={() => {
                                    el.onClick();
                                    setIsMenu(false);
                                }}
                                className={s.dropdown_row}
                            >
                                {el.icon}
                                <div className={s.dropdown_item}>
                                    {el.label}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </Divider>
    );
};
